import React from "react";
import { withStableUniqueId } from "react-stable-uniqueid";

const Scarf1 = ({ uniqueId }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 478.88 567.36">
    <ellipse
      cx="372.93"
      cy="223.54"
      rx="13.38"
      ry="12.26"
      transform="translate(38.02 500.81) rotate(-70.56)"
      fill="#cb0000"
    />
    <path
      d="M127.07,181.84s126.83,6.21,237,44.79c0,0,17.83-24.83,6.83-44.63s-219.51-19.25-229.41-21.46S129.57,174.47,127.07,181.84Z"
      fill="#cb0000"
    />
    <path
      d="M382.57,210.5s26.8-21.57,60-2.61c0,0-21.2,17.77-43.55,10.53,0,0,33.6,9.18,39.44,39.29,0,0-40.78-2.4-64-38.4C374.46,219.31,376.3,212.59,382.57,210.5Z"
      fill="#cb0000"
    />
  </svg>
);

export default withStableUniqueId()(Scarf1);



// WEBPACK FOOTER //
// ./src/components/Pirate/accessories/head/Scarf1.js